import { render, staticRenderFns } from "./GetQuoteBlock.vue?vue&type=template&id=78f4adda&scoped=true&"
import script from "./GetQuoteBlock.vue?vue&type=script&lang=js&"
export * from "./GetQuoteBlock.vue?vue&type=script&lang=js&"
import style0 from "./GetQuoteBlock.vue?vue&type=style&index=0&id=78f4adda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f4adda",
  null
  
)

export default component.exports